import Collection from '../../utils/Collection';

import {
  FETCH_TIMESLOT_STATUSES_SENT,
  FETCH_TIMESLOT_STATUSES_SUCCEEDED,
  FETCH_TIMESLOT_STATUSES_FAILED,
} from '../../actions/timeslot';

import {
  BOOK_SUCCEEDED,
  CANCEL_BOOKING_SUCCEEDED,
} from '../../actions/booking';

const initialState = {
  loading: false,
  slotStatuses: [],
  tutorAvailabilityList: {},
  lastFilterOpts: {},
};

export default function tutorListTimeslotReducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case FETCH_TIMESLOT_STATUSES_SUCCEEDED:
      return {
        ...state,
        loading: false,
        slotStatuses: Collection.reset(state.slotStatuses, payload.slot_status),
      };
    case FETCH_TIMESLOT_STATUSES_FAILED:
      return {
        ...state,
        loading: false,
      };
    case FETCH_TIMESLOT_STATUSES_SENT:
      return {
        ...state,
        loading: true,
        lastFilterOpts: payload.opts,
      };
    case BOOK_SUCCEEDED:
    case CANCEL_BOOKING_SUCCEEDED:
      return {
        ...state,
        slotStatuses: Collection.updateMany(
          state.slotStatuses,
          payload.changedStatuses,
        ),
      };
    default:
      return state;
  }
}
